var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NewItem',{ref:"newItem",attrs:{"button-title":"Add New Output"}},[_c('template',{slot:"form"},[_c('OutputNewForm',{on:{"close":_vm.close}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }